import './JobsPanel.css';
import { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../../authContext';
import { useTranslation } from 'react-i18next';

function JobsPanel({ assistantId }) {
    const { accessToken } = useContext(AuthContext);

    const [results, setResults] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const { t: tChat, i18n } = useTranslation('chat');
    const { t: tCommon } = useTranslation('common');

    const fetchResults = async () => {
        if (!assistantId) return;

        setIsLoading(true);

        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/get_results?assistant_id=${assistantId}`,
                {
                    method: "GET",
                    headers: {
                        "Authorization": `Bearer ${accessToken}`
                    },
                    cache: "no-store",
                }
            );

            if (response.ok) {
                const data = await response.json();
                setResults(data);
            } else {
                console.error("Erro ao buscar resultados");
                setResults([]);
            }

        } catch (err) {
            console.error("Erro na requisição:", err);
            setResults([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchResults();
    }, [assistantId]);

    // Função para agrupar e classificar os resultados
    const groupResults = (data) => {
        const today = [];
        const last7Days = [];
        const older = [];

        const now = new Date();
        // Zera as horas para comparar os dias exatos, independente do horário da análise
        const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        data.forEach((item) => {
            const itemDate = new Date(item.creation_time);
            const startOfItemDate = new Date(itemDate.getFullYear(), itemDate.getMonth(), itemDate.getDate());

            // Calcula a diferença em dias corridos
            const diffTime = startOfToday.getTime() - startOfItemDate.getTime();
            const diffDays = diffTime / (1000 * 3600 * 24);

            if (diffDays <= 0) {
                // Hoje (ou eventuais diferenças de fuso horário que apontem para o futuro)
                today.push(item);
            } else if (diffDays > 0 && diffDays <= 7) {
                // Últimos 7 dias
                last7Days.push(item);
            } else {
                // Mais de 7 dias (+ 7 dias)
                older.push(item);
            }
        });

        return { today, last7Days, older };
    };

    const { today, last7Days, older } = groupResults(results);

    // Função auxiliar para renderizar cada seção dinamicamente
    const renderGroup = (title, items, groupIndex) => {
        return (
            <div className={`jobs-group ${groupIndex === 0 ? 'first-group' : 'secondary-group'}`}>
                <h4 className="jobs-group-title">{title}</h4>
                <div className="jobs-list">
                    {items.map((item, index) => (
                        <div key={index} className="job-item">
                            <p className="job-filename" title={item.filename}>{item.filename}</p>
                            <div className='job-wrapper-date-download'>
                                <p className="job-date">
                                    {new Date(item.creation_time).toLocaleString(i18n.language)}
                                </p>
                                <a
                                    className="job-download-btn"
                                    href={item.download_url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src="/imagens/download-gray.svg" alt={tCommon('downloadIcon')} title={tCommon('downloadIcon')}/>
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    return (
        <div className="jobs-panel">
            <div className="jobs-panel-header">
                <h3>{tChat('analises')}</h3>

                <img
                    src="/imagens/rotate-ccw.svg"
                    alt={tCommon('refreshAnalysesAlt')}
                    className={`jobs-load-image ${isLoading ? 'loading' : ''}`}
                    onClick={!isLoading ? fetchResults : undefined}
                />
            </div>

            {!isLoading && results.length === 0 && (
                <div className="jobs-empty">
                    <p>{tChat('sem_analise')}</p>
                </div>
            )}

            {!isLoading && results.length !== 0 && (
                <div className="jobs-grouped-container">
                    {renderGroup(tChat('today'), today, 0)}
                    <hr />
                    {renderGroup(tChat('days_ago'), last7Days, 1)}
                    <hr />
                    {renderGroup(tChat('older'), older, 2)}
                </div>
            )}
        </div>
    );
}

export default JobsPanel;
